<template>
  <div>
    <div  
    @click="togglerDark"
      v-if="!$root.isDarkMood"
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
      class="cursor-pointer absolute z-50 left-16 md:left-8 -top-2"
    >
      <img
        class="jello-horizontal w-32 md:w-auto"
        src="images/tiethesun.svg"
        alt=""
      />
    </div>
    <div  
    @click="togglerDark"
      v-if="$root.isDarkMood"
      style="cursor : pointer;"
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
      class="cursor-pointer absolute z-50 left-16 md:left-6 top-2"
    >
      <img
        class="jello-horizontal w-32 md:w-auto"
        src="images/nightMood.svg"
        alt=""
      />
    </div>
    <header
      class="z-40 w-full mx-auto px-10 md:px-32 lg:px-56 xl:px-72 pt-10 fixed"
    >
      <nav class="flex justify-between items-center">
        <div>
          <a
            href="#home"
            class="
              absolute
              animate-ping
              focus:outline-none
              text-logo text-md
              md:text-lg
              xl:text-xl
              font-bold
            "
            >PK</a
          >
          <a
            href="#home"
            class="
              focus:outline-none
              text-logo text-md
              md:text-lg
              xl:text-xl
              font-bold
            "
            >PK</a
          >
        </div>
        <div>
          <!-- moon -->
          <button
            v-if="$root.isDarkMood"
            @click="togglerDark"
            id="theme-toggle"
            class="animate-pulse"
          >
            <svg
              id="moon"
              class="w-4 h-4 md:w-6 md:h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
              ></path>
            </svg>
          </button>
          <!-- sun -->
          <button
            v-if="!$root.isDarkMood"
            @click="togglerDark"
            id="theme-toggle"
            class="animate-spin"
          >
            <svg
              :class="[$parent.isDarkMood ? '' : 'text-yellow-500']"
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4 md:w-6 md:h-6"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  created(){
    // console.log(this.$root.isDarkMood)
  },
  methods: {
    togglerDark() {
      let darkMode = localStorage.getItem("darkMode");
      if (darkMode == "false" || darkMode == null) {
        if (darkMode == null) {
          this.$root.isDarkMood = true;
          document.body.style.backgroundColor = "#151B3C";
          localStorage.setItem("darkMode", true);
        }
        if (darkMode == "false") {
          this.$root.isDarkMood = false;
          document.body.style.backgroundColor = "rgba(255 , 255, 255, 0.4)";
          localStorage.setItem("darkMode", true);
        }
      } else if (darkMode == "true") {
        this.$root.isDarkMood = true;
        document.body.style.backgroundColor = "#151B3C";
        localStorage.setItem("darkMode", false);
      }

      // this.$root.isDarkMood = !this.$parent.isDarkMood;
      // if (!this.$parent.isDarkMood) {
      //   localStorage.setItem("darkMode", "off");
      //   document.body.style.backgroundColor = "rgba(255 , 255, 255, 0.4)";
      // } else if (this.$parent.isDarkMoo) {
      //   localStorage.setItem("darkMode", "on");
      //   document.body.style.backgroundColor = "#151B3C";
      // }
    },
  },
};
</script>

<style>
</style>